(function() {
    const singleProduct = document.querySelector('.jsSingleProduct');

    if (singleProduct) {
        const productImages = singleProduct.querySelector('.jsProductImages');
        new Flickity(productImages, {
            adaptiveHeight: true,
            prevNextButtons: true,
            pageDots: true
        });
    }
})();
